import React, { useState, useEffect } from 'react'

export default function Alert(props) {
    //backgroundColor: props.bgcolor, height: '55px', 
    // alert-${props.alert.type}
    const [bgColor, SetbgColor] = useState("white");
    useEffect(() => {
        if (props.alert !== null) {
            if (props.alert.type === "success") { 
                SetbgColor("green");
            }
            else if (props.alert.type === "danger") { 
                SetbgColor("red");
            }
            else if (props.alert.type === "warning") { 
                SetbgColor("yellow");
            }
            else {
                SetbgColor("white");
            }
        }
    }, [props.alert]);
  return (
    <>
        {
            props.alert ? (
                <>
                    <div style={{position: 'fixed', zIndex: '300', width: '100%'}}>
                        <div style={{zIndex: '300', height: '100%', padding: '20px', marginTop: '0px', backgroundColor: bgColor, width: '100%'}}>
                            <strong style={{color: 'white'}}>
                                {
                                    props.alert.type === "success" ? (
                                        <>Success...</>
                                    ) : props.alert.type === "warning" ? (
                                        <>Please Wait...</>
                                    ) : props.alert.type === "danger" ? (
                                        <>Reverted: </>
                                    ) : (
                                        <></>
                                    )
                                } {props.alert.message}
                            </strong>
                        </div>
                    </div>
                    {/*<div style={{position: 'fixed', zIndex: '16', width: '100%'}}>
                        <div style={{zIndex: '16', height: '100%', padding: '20px', marginBottom: '15px', backgroundColor: bgColor, width: '100%'}}>
                            <strong style={{color: 'white'}}>
                                {
                                    props.alert.type === "success" ? (
                                        <>Success...</>
                                    ) : props.alert.type === "warning" ? (
                                        <>Please Wait...</>
                                    ) : props.alert.type === "danger" ? (
                                        <>Reverted: </>
                                    ) : (
                                        <></>
                                    )
                                } {props.alert.message}
                            </strong>
                        </div>
                    </div>*/}
                </>
            ) : (
                <>
                </>
            )
        }
        
    </>
  )
}
